import React from "react";
import axios from "@/utils/myaxios";
import moment from "moment";
import { Link } from "react-router-dom";
import {
    Button,
    Table,
    message,
    DatePicker,
    Modal,
    Pagination,
    InputNumber,
    Spin,
    Empty,
    Form,
    Select,
} from "antd";
import { statusList5, kindList } from "@/utils/constant";
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import HandDetail from "@/pages/commom/HandDetail";

export default class ActivityLuckycardRewardReview extends React.Component {
    state = {
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        show: false, // 是否显示弹窗
        loading: false, // 是否加载中
        detailLoading: false, // 详情是否加载中
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            date: [],
            uid: undefined,
            status: undefined,
        },
        detailQueryParams: {
            // 详情查询参数
            page: 1,
            limit: 1,
            total: 0,
            mid: undefined,
        },
        data: [], // 表格数据
        selectedData: {}, // 选中的表格数据
        detailInfo: {}, // 活动详情数据
        handCardData: {}, // 手牌详情
        formData: {}, // 表单数据
        statusList: statusList5, // 状态列表
        kindList: kindList,// 游戏列表
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/activity_get_lucky_card_audit_list", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    activityList: res.data || [],
                });
            });
    };

    /**
     * 获取活动详情
     */
    fetchDetail = (item) => {
        this.setState({ detailLoading: true });
        axios
            .get("/v1/api/activity_get_lucky_card_hit_user_inspect", {
                params: {
                    uid: item.uid,
                    tunix: item.tunix,
                },
            })
            .then((res) => {
                this.setState({
                    detailLoading: false,
                    detailInfo: res.data || {},
                });
            });
    };

    /**
     * 获取手牌详情数据
     */
    fetchHandCardData = () => {
        this.setState({ detailLoading: true });
        axios
            .get("/v1/api/union_game_detail", {
                params: {
                    ...this.state.detailQueryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    detailLoading: false,
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        total: res.count || 0,
                    },
                    handCardData: res.data || {},
                });
            });
    };

    /**
     * 操作补发，不补发
     */
    handleOperation = (type, item) => {
        Modal.confirm({
            title: this.props.language['hint'],
            content: type === 'reissue' ? this.props.language['reissueConfirm'] : this.props.language['noReissueConfirm'],
            onOk: () => {
                axios
                    .post('/v1/api/activity_audit_lucky_card_record', {
                        id: item.id,
                        approve: type === 'reissue' ? true : false,
                    }
                    )
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(
                                this.props.language['operationSuccessMessage']
                            )
                            this.fetchData()
                        }
                    })
            },
        })
    };

    /**
     * 显示弹窗
     */
    handleShow = (type, item) => {
        if (type === "detail") {
            // 活动明细
            this.setState(
                {
                    type,
                    show: true,
                    selectedData: item,
                    detailInfo: {},
                    title: this.props.language["userDataQuery"],
                },
                () => this.fetchDetail(item)
            );
        } else if (type === "handCard") {
            // 手牌详情
            this.setState(
                {
                    title: this.props.language["handDetail"],
                    type,
                    show: true,
                    selectedData: item,
                    handCardData: {},
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: 1,
                        mid: item.mid,
                        uid: undefined,
                    },
                },
                () => this.fetchHandCardData()
            );
        }
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination, type) => {
        if (type === "handCard") {
            // 手牌详情数据
            this.setState(
                {
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: pagination.current,
                    },
                },
                () => this.fetchHandCardData()
            );
        } else {
            this.setState(
                {
                    queryParams: {
                        ...this.state.queryParams,
                        page: pagination.current,
                        limit: pagination.pageSize,
                    },
                },
                () => this.fetchData()
            );
        }
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value, type) => {
        if (type === "handCard") {
            this.setState(
                {
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: 1,
                        [key]: value,
                    },
                },
                () => this.fetchHandCardData()
            );
        } else {
            this.setState({
                queryParams: { ...this.state.queryParams, page: 1, [key]: value },
            });
        }
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    uid: undefined,
                    status: undefined,
                    date: [],
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["playerIdPlaceholder"]}
                        value={this.state.queryParams.uid}
                        onChange={(value) => this.handleSetQueryParamsData("uid", value)}
                    />
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["statusPlaceholder"]}
                        value={this.state.queryParams.status}
                        onChange={(value) => this.handleSetQueryParamsData("status", value)}
                    >
                        {this.state.statusList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <DatePicker.RangePicker
                        value={this.state.queryParams.date}
                        onChange={(e) => this.handleSetQueryParamsData("date", e)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.activityList}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ["10", "20", "30", "40"],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={this.hanldeChangePage}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["hitDate"]}
                            dataIndex="hit_time"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playerId"]}
                            dataIndex="uid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playerName"]}
                            dataIndex="name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gambleId"]}
                            dataIndex=""
                            render={(item) => (
                                <Button
                                    type="link"
                                    onClick={() => this.handleShow("handCard", item)}
                                >
                                    {item.mid}
                                </Button>
                            )}
                        />
                        <Table.Column align="center" title="BB" dataIndex="bb" />
                        <Table.Column
                            align="center"
                            title={this.props.language["handId"]}
                            dataIndex="hid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["thatTimeAward"]}
                            dataIndex="hit_pot"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["hitCount"]}
                            dataIndex="hit_count"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gameType"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.kindList.find(
                                    (kindItem) => kindItem.value === item.kind
                                )
                                    ? this.state.kindList.find(
                                        (kindItem) => kindItem.value === item.kind
                                    ).label
                                    : ""
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["currentBlind"]}
                            dataIndex=""
                            render={(item) => `${item.sb}/${item.bb}(${item.ante})`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["status"]}
                            dataIndex=""
                            render={(item) => {
                                return item.status === 2 ?
                                    <>
                                        <Button
                                            className="btn-green-ghost"
                                            onClick={() => this.handleOperation('reissue', item)}
                                        >
                                            {this.props.language["reissue"]}
                                        </Button>
                                        <Button
                                            className="ml10"
                                            ghost
                                            type="danger"
                                            onClick={() =>
                                                this.handleOperation('noReissue', item)
                                            }
                                        >
                                            {this.props.language["noReissue"]}
                                        </Button>
                                    </> :
                                    item.status === 3 || item.status === 5 ?
                                        <p style={{ color: '#67c23a' }}>{item.status_desc}</p>
                                        :
                                        item.status === 4 || item.status === 6 ?
                                            <p style={{ color: '#ff4d4f' }}>{item.status_desc}</p>
                                            : ''
                            }}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={120}
                            render={(item) => (
                                <Button
                                    type="default"
                                    onClick={() => this.handleShow("detail", item)}
                                >
                                    {this.props.language["userDataQuery"]}
                                </Button>
                            )}
                        />
                    </Table>
                </div>

                {/* 详情弹窗 */}
                <DetailModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    loading={this.state.detailLoading}
                    pagination={{
                        showTotal: (total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                        showQuickJumper: true,
                        current: this.state.detailQueryParams.page,
                        pageSize: this.state.detailQueryParams.limit,
                        total: this.state.detailQueryParams.total,
                        size: isMobileDevice() ? 'small' : '',
                    }}
                    selectedData={this.state.selectedData}
                    detailInfo={this.state.detailInfo}
                    handCardData={this.state.handCardData}
                    detailQueryParams={this.state.detailQueryParams}
                    handleSetQueryParamsData={this.handleSetQueryParamsData}
                    onCancel={() => this.setState({ show: false })}
                    onChange={(pagination) =>
                        this.hanldeChangePage(
                            { current: pagination },
                            "handCard"
                        )
                    }
                />
            </div>
        );
    }
}

/**
 * 详情弹窗
 */
class DetailModal extends React.Component {
    render () {
        let handCardTitle = (
            <div className='container-header p0'>
                {this.props.handCardData.hand_time && (
                    <>
                        <span>{this.props.title}</span>
                        <span>（{this.props.handCardData.id}）</span>
                        <span className="mr20">
                            {this.props.handCardData.hand_time
                                ? this.props.handCardData.hand_time
                                : ""}
                        </span>
                    </>
                )}
                <InputNumber
                    precision={0}
                    min={0}
                    max={100000000}
                    placeholder={this.props.language["playerIdPlaceholder"]}
                    value={this.props.detailQueryParams.uid}
                    onChange={(value) =>
                        this.props.handleSetQueryParamsData("uid", value, "handCard")
                    }
                />
            </div>
        );

        return (
            <Modal
                maskClosable={false}
                width={1600}
                title={
                    this.props.type === "handCard" ? handCardTitle : this.props.title
                }
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                centered={isMobileDevice()}
                bodyStyle={{
                    maxHeight: this.props.type === "handCard" ? '60vh' : '70vh',
                    overflowY: "auto",
                }}
                footer={
                    this.props.type === "handCard" ? (
                        <Pagination
                            showQuickJumper
                            {...this.props.pagination}
                            showTotal={(total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                            }
                            size={isMobileDevice() ? 'small' : ''}
                            onChange={this.props.onChange}
                        />
                    ) : null
                }
            >
                <div className="container-content">
                    {/* 用户数据筛选 */}
                    {this.props.type === "detail" && (
                        <Table
                            dataSource={[this.props.detailInfo]}
                            pagination={false}
                            loading={this.props.loading}
                            scroll={{ x: true }}
                            rowKey={(record, index) => index}
                        >
                            <Table.Column
                                align="center"
                                title={this.props.language["playerId"]}
                                dataIndex="uid"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["totalHand"]}
                                dataIndex="total"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["discardedHandNumber"]}
                                dataIndex="fold"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["notServiceFeeHandNumber"]}
                                dataIndex="unfee"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["betBoolHandNumber"]}
                                dataIndex="pot_less_10bb"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["enterBollHandNumber"]}
                                dataIndex="pool_entry"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["drawHandNumber"]}
                                dataIndex="flop_entry"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["notBetBoolHandNumber"]}
                                dataIndex="unpotfee"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["twoPeopleGambleHandNumber"]}
                                dataIndex="player2"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["threePeopleGambleHandNumber"]}
                                dataIndex="player3"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["notLuckfeeHandNumber"]}
                                dataIndex="unluck_card_fee"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["totalContributeServiceFee"]}
                                dataIndex="fee"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["everyHandServiceFeeBb"]}
                                dataIndex="fee_bb"
                            />
                        </Table>
                    )}

                    {/* 手牌详情 */}
                    {this.props.type === "handCard" && (
                        <Spin spinning={this.props.loading}>
                            {this.props.handCardData.id && (
                                <>
                                    {/* NLH, AOF, PLO, AOF */}
                                    <HandDetail
                                        {...this.props}
                                        handCardData={this.props.handCardData}
                                        squidConf={this.props.selectedData.squid_conf}
                                        searchPlayer={{
                                            uid1: this.props.detailQueryParams.uid,
                                        }}
                                    />
                                </>
                            )}

                            {/* 暂无数据 */}
                            {!this.props.handCardData.id && (
                                <>
                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                </>
                            )}
                        </Spin>
                    )}
                </div>
            </Modal>
        );
    }
}
